<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32">
        <title>cost</title>
        <path :fill="color"
         d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2m3.6 7.2a1 1 0 0 0-1.4.2L16 12.333 13.8 9.4a1 1 0 1 0-1.6 1.2l2.551 3.4H12a1 1 0 0 0-.993.883L11 15a1 1 0 0 0 1 1h3v2h-3a1 1 0 0 0-.993.883L11 19a1 1 0 0 0 1 1h3v2a1 1 0 0 0 .883.993L16 23a1 1 0 0 0 1-1v-2h3a1 1 0 0 0 .993-.883L21 19a1 1 0 0 0-1-1h-3v-2h3a1 1 0 0 0 .993-.883L21 15a1 1 0 0 0-1-1h-2.751l2.551-3.4a1 1 0 0 0-.104-1.319z"/></svg>
</template>
<script setup lang="ts">
defineProps({
    color: {
        type: String,
        default: 'currentColor'
    }
});
</script>
